// facade for testing
let document: any
if (!window.document.cookie) {
  document = { cookie: '' }
} else {
  document = window.document
}

export const getCookie = (cookieName: string) => {
  const cookieRegex = new RegExp(`${cookieName}=([^;]+)`)
  const cookieVal = cookieRegex.exec(document.cookie)
  return cookieVal !== null ? unescape(cookieVal[1]) : null
}

export const setCookie = (cookieName: string, cookieVal: string) => {
  let cookieString = `${cookieName}=${cookieVal}; `

  if (process.env.REACT_APP_ENV !== 'development') {
    cookieString += 'path=/;domain=.bankrate.com;'
  }

  const cookieExpiration = new Date()

  document.cookie = `${cookieString} expires=${cookieExpiration.setDate(cookieExpiration.getDate() + 1)}`
}

export const deleteCookie = (cookieName: string) => {
  document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`
}
